import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installmentconfig',
  templateUrl: './installmentconfig.component.html',
  styleUrls: ['./installmentconfig.component.css']
})
export class InstallmentconfigComponent implements OnInit {

  title="Installment Configuration";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/installmentconfig/installmentconfig.component.ts